module.exports = __webpack_public_path__ + "static/olivia_edited-93ce205a96a3c38acfd99447a30525aa.jpg";